module.exports = __webpack_public_path__ + "img/图片8.0b2d68c0.png";